export const isValidUSPhoneNumber = (phone: string): boolean => {
  // Validates 10-digit US numbers, optionally prefixed with +1 or 1, and common separators.
  const phoneRegex = /^(?:\+?1)?[-.\s]?\(?(\d{3})\)?[-.\s]?(\d{3})[-.\s]?(\d{4})$/;
  return phoneRegex.test(phone);
};
